import React from 'react';
import cn from 'classnames';
import { Segmented } from 'antd';
import type { DesignMode } from 'common/design-tokens';
import css from './DesignModeControl.scss';

type Props = {
	modes: DesignMode[];
	value?: string;
	disabled?: boolean;
	className?: string;
	ariaLabel?: string;
	onChange: (value: string) => void;
};

export default function DesignModeControl({
	modes,
	value,
	disabled,
	className,
	ariaLabel = 'Editing mode',
	onChange,
}: Props) {
	return (
		<Segmented<string>
			className={cn(css.control, className)}
			size="large"
			aria-label={ariaLabel}
			value={value}
			disabled={disabled}
			options={modes.map(mode => ({
				value: mode.id,
				label: (
					<span className={css.option}>
						<span
							className={cn(css.preview, {
								[css.previewDark]: mode.colorScheme === 'dark',
								[css.previewLight]: mode.colorScheme !== 'dark',
							})}
							aria-hidden
						>
							Aa
						</span>
						<span>{mode.name}</span>
					</span>
				),
			}))}
			onChange={onChange}
		/>
	);
}
